import styled from '@emotion/styled'

export const FooterContentWrapper = styled.div`
  width: 100%;
`
